import { DateTime } from 'luxon';
import { DuplicateShiftBooking, NewShiftBooking, ShiftBooking } from 'utils/FlexApi';

// Disabling Naming convention due to API contract.
/* eslint-disable @typescript-eslint/naming-convention */
export interface SerializedNewShiftBooking {
    new_shift_booking_id: string;
    worker_name?: string;
}

export interface SerializedShiftBooking {
    shift_booking_id: string; // Flex ShiftBooking.id
    worker_name: string;
    worker_email?: string;
    role_name: string;
    client: string;
    venue_name: string;
    pay_rate: {
        amount: number;
        currency: string;
    };
    job_id: string;
    break_duration: number;
    timezone: string;
    shift_start: string; // Should be serialized to ISO 8601
    shift_end: string; // Should be serialized to ISO 8601
}

export interface SerializedDuplicateShiftBooking {
    shift_booking_id: string;
    start_time: string;
    end_time: string;
    supervisor_name: string;
    notes: string;
}

export interface SerializedShift {
    id: number;
    job_id: number;
    listing_id: number;
    platform_id?: number;
    role_id: number;
    pay_rate: {
        amount: number;
        currency: string;
    };
    start_time: string; // Should be serialized to ISO 8601
    end_time: string; // Should be serialized to ISO 8601
    // TODO Not a complete interface, add additional properties from the returning interface as needed.
}

export const serializeDuplicateShiftBooking = (shift: DuplicateShiftBooking): SerializedDuplicateShiftBooking => ({
    shift_booking_id: shift.shiftBookingId,
    start_time: shift.startTime.toISOString(),
    end_time: shift.endTime.toISOString(),
    supervisor_name: shift.supervisorName,
    notes: shift.notes,
});

export const deserializeShiftBooking = (serializedShiftBooking: SerializedShiftBooking): ShiftBooking => ({
    shiftBookingId: serializedShiftBooking.shift_booking_id,
    workerName: serializedShiftBooking.worker_name,
    workerEmail: serializedShiftBooking.worker_email,
    client: serializedShiftBooking.client,
    timezone: serializedShiftBooking.timezone || DateTime.local().zoneName,
    venueName: serializedShiftBooking.venue_name,
    roleName: serializedShiftBooking.role_name,
    payRate: {
        amount: serializedShiftBooking.pay_rate.amount,
        currency: serializedShiftBooking.pay_rate.currency,
    },
    shiftStart: DateTime.fromISO(serializedShiftBooking.shift_start).toJSDate(),
    shiftEnd: DateTime.fromISO(serializedShiftBooking.shift_end).toJSDate(),
    breakDuration: serializedShiftBooking.break_duration,
    jobId: serializedShiftBooking.job_id,
});

export const deserializeNewShiftBooking = (serializedNewShiftBooking: SerializedNewShiftBooking): NewShiftBooking => ({
    shiftBookingId: serializedNewShiftBooking.new_shift_booking_id,
    workerName: serializedNewShiftBooking.worker_name,
});

/* eslint-enable @typescript-eslint/naming-convention */
